export const formatTierName = (tierName: string): string => {
  const match = tierName.match(/^Tier(\d+)$/i);
  if (match && match[1]) {
    const number = match[1];
    return number ? `Tier ${number}` : tierName;
  }
  return tierName;
};
